import clsx from 'clsx';
import { Box } from '@mantine/core';

interface IChatMessagePaperTriangleProps {
  fromMe: boolean;
}

export default function ChatMessagePaperTriangle({
  fromMe,
}: IChatMessagePaperTriangleProps) {
  return (
    <Box
      className={clsx(
        'h-0 w-0',
        'border-t-10',
        fromMe ? 'border-t-brand-100' : 'border-t-white',
        fromMe
          ? 'border-r-8 border-r-transparent'
          : 'border-l-8 border-l-transparent'
      )}
    />
  );
}
